import SupportAgentIcon from '@guildeducationinc/recess/icons/SupportAgentIcon';
import CoachPictogram from '@guildeducationinc/recess/pictograms/CoachPictogram';
import ContactCardButton from '@src/components/GuildSupport/ContactCardButton/ContactCardButton';
import ContactCardWrapper from '@src/components/GuildSupport/ContactCardWrapper/ContactCardWrapper';
import { ComponentDataKey } from '@src/components/Pages/Home/Layout/config';
import { clickable } from '@src/analytics';
import { useEmployerContent } from '@src/context/EmployerContentContext';

declare const window: any;

export interface CoachContactCardProps {
  coachCalendlyLink: string;
}

const CoachContactCard: React.FC<CoachContactCardProps> = ({ coachCalendlyLink = '' }) => {
  const { [ComponentDataKey.COACH_CONTACT_CARD]: content } = useEmployerContent() ?? {};

  const handleScheduleCall = () => {
    if (coachCalendlyLink) {
      clickable({
        product: 'home',
        loggedIn: true,
        tag: 'guild_support_schedule_call',
        text: 'schedule_a_call',
        type: 'link',
        external_url: coachCalendlyLink,
      });

      if (window.Calendly) {
        window.Calendly.initPopupWidget({ url: coachCalendlyLink });
      }
    }
  };
  return (
    <ContactCardWrapper
      description={content?.description}
      heading={content?.heading}
      Icon={CoachPictogram}
    >
      <ContactCardButton
        disabled={!coachCalendlyLink}
        Icon={SupportAgentIcon}
        onClick={handleScheduleCall}
        onKeyDown={handleScheduleCall}
        testid='scheduleCallButton'
        text='Schedule a call'
      />
    </ContactCardWrapper>
  );
};

export default CoachContactCard;
